export default __webpack_public_path__ + "/dist/images/logo10.7a4e86f0bf78f5ab6a2e251ad5f239ff.jpg";